import React from 'react';
import usePageMeta from '../hooks/usePageMeta';
import styles from './bodytext.module.css'; // Import the CSS module
import aboutStyles from './About.module.css';

const About = () => {
  usePageMeta(
    'About Us & Opening Times | Vintage in Oulton',
    'Find out about Vintage in Oulton and check our opening times, including weekday and weekend hours for our antiques shop in Oulton, Leeds.'
  );
  return (
    <div className={aboutStyles.layout}>
      <div className={styles.textContainer}>
        <h2>About Us</h2>
        <p>
          Vintage in Oulton is your destination for quality vintage and antique
          items, Annie Sloan paint, and more. Our curated collection features a
          wide range of unique pieces sourced from around the world.
        </p>
        <p>
          Please call ahead if you're travelling far, as our opening hours —
          including on public holidays — can occasionally change. Check
          Google, our social media, or give us a call for the latest.
        </p>
      </div>
      <div className={styles.textContainer}>
        <h2>Opening Times</h2>
        <div className={styles.hoursList}>
          <p>Monday: Closed</p>
          <p>Tuesday: Closed</p>
          <p>Wednesday: 10:00-17:00</p>
          <p>Thursday: 10:00-17:00</p>
          <p>Friday: 10:00-17:00</p>
          <p>Saturday: 10:00-17:00</p>
          <p>Sunday: 11:00-16:00</p>
        </div>
      </div>
    </div>
  );
};

export default About;
